module.exports = __webpack_public_path__ + "img/receipt_outline.279641c0.svg";